var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogoFormulario',{ref:"dialog",attrs:{"title":"Atualizar local de estoque","submit-text":"Atualizar","handler":_vm.handler},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var form = ref.form;
var errors = ref.errors;
return [_c('v-text-field',{attrs:{"autofocus":"","label":"Nome","error-messages":errors.nome,"outlined":""},model:{value:(form.nome),callback:function ($$v) {_vm.$set(form, "nome", $$v)},expression:"form.nome"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }